export default () => jQuery(($) => {
	$('.imgAfterload').each(function () {
		var image_wrapper = $(this);
		var image_data_url = image_wrapper.attr('data-src');
		var use_placeholder_class = image_wrapper.attr('data-placeholder-class');
		$.ajax({
				url: image_data_url,
				type: 'GET',
				dataType: 'json',
				success: function (data) {
					// console.log(data);
					if (data.data.src) {
						image_wrapper.html(`<img src="${data.data.src}" class="${data.data.className}" alt="${data.data.alt}" width="${data.data.width}" height="${data.data.height}">`);
					} else if (use_placeholder_class) {
						image_wrapper.html(`<div class="${use_placeholder_class}" style="width: ${data.data.width ? data.data.width : '75%'}; height: ${data.data.height ? data.data.height : '100%'};" title="${data.data.alt}">${data.data.title ? data.data.title.replace(/\\(.)/mg, "$1") : data.data.alt}</div>`);
					}
				},
				error: function (request, error) {
					console.error(`Request: ${JSON.stringify(request)}`, error);
				}
			},
		);
	});
});
